export default "assets/images/flags/gb-f2870036.svg";